class AssignStudents {
    // @ngInject
    constructor($scope, $rootScope, authService, localStorageService, $state, activityCons, $mdMedia, $mdDialog, $stateParams) {
        this.scope = $scope;
        this.state = $state;
        let authoring = localStorageService.get("authoringData")
        let userId = localStorageService.get('user_id')
        let academicDetails = {
            session_id: authoring.session_id,
            curriculum_id: authoring.curriculum_id,
            class_id: authoring.class_id,
            batch_id: authoring.batch_id,
            school_id: authoring.school_id,
            subject_id: authoring.subject_id,
            academic_year: authoring.academic_year,
            user_id: userId,
            class: authoring.class,
            batch: authoring.batch,
            curriculum: authoring.curriculum,
            session: authoring.session,
            subject: authoring.subject
        }

        //Boolean - Assign all students or  not
        $scope.isAllStudents = false;

        //Boolean - Assign all groups or not
        $scope.isAllGroups = false;

        //[Object] - List of all students in the class
        $scope.allStudents = [];

        //[Object] - List of groups
        $scope.groupList = [];

        let qpId = $state.params.qpId

        //Object - basic academic details
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
            if (authoring) {
                authoring['user_id'] = userId
                getGroupList()
                getAllStudents()
            } else {
                $state.go("authdashboard")
            }
        }

        //Object - Assigned users
        $scope.assignedUsers = {};

        //[Object] - Selected Groups
        $scope.selectedGroupList = [];

        //[Object] - Selected Students
        $scope.selectedStudentList = [];

        $scope.isServerCall = false;

        let subsGroup = undefined

        this.$onDestroy = () => {
            if (subsGroup)
                subsGroup.stop()
        }

        if ($stateParams.previousState.state !== "") {
            localStorageService.set('assignUserHistory', $stateParams.previousState);
            //Object - State param
            $scope.previousState = $stateParams.previousState;
        } else {
            $scope.previousState = localStorageService.get('assignUserHistory')
        }

        if ($scope.previousState == null || $scope.previousState == undefined || $scope.previousState == '') {
            $state.go('qpSummary', {
                qpId: $stateParams.qpId
            });
        }

        function getAllStudents() {
            authService.callAPI(activityCons.API_GET_STUDENT_LIST, "POST", academicDetails, function(response) {
                if (response && response.result && response.result.data) {
                    if (response.result.data.data.length > 0)
                        $scope.allStudents = response.result.data.data
                    console.log($scope.allStudents)
                    $scope.$apply()
                }
            })
        }

        function getGroupList() {
            authService.callAPI(activityCons.API_GET_GROUP_DETAILS, "POST", academicDetails, function(response) {
                if (response && response.result && response.result.data) {
                    let groupList = response.result.data.data
                    authService.callAPI(activityCons.API_GET_ASSIGNED_USERS + qpId, "GET", {}, function(response) {
                        if (response && response.result && response.result.data) {
                            let result = response.result.data.data
                            _.each(groupList, function(group) {
                                let isLeader = false;
                                let leaderName = '';
                                _.each(group.students, function(student) {
                                    if (student.leader) {
                                        isLeader = true;
                                        if (leaderName === '')
                                            leaderName = student.name;
                                        else
                                            leaderName += ", " + student.name;
                                    }
                                })
                                group.isLeader = isLeader;
                                group.leaderName = leaderName;
                                group.isSelected = false;
                                if (result && result.group_Ids && result.group_Ids.length > 0) {
                                    let assignGroup = _.find(result.group_Ids, function(obj) {
                                        return group._id == obj._id
                                    })
                                    if (assignGroup) {
                                        group.isSelected = true;
                                        $scope.selectedGroupList.push({
                                            _id: group._id
                                        });
                                    }
                                }
                            })
                            if (result && result.group_Ids && result.group_Ids.length == groupList.length)
                                $scope.isAllGroups = true


                            if (result && result.students && result.students.length > 0) {
                                let list = []
                                _.each($scope.allStudents, function(student) {
                                    list.push({
                                        _id: student._id,
                                        name: student.name
                                    });
                                })
                                $scope.selectedStudentList = list;
                                $scope.isAllStudents = true;
                            }
                            $scope.groupList = groupList;
                            _.defer(function() {
                                $scope.$apply();
                            });
                        }
                        _.defer(function() {
                            $scope.$apply();
                        });
                    })
                }
            })
        }

        $scope.allStudentsSelected = () => {
            $scope.isServerCall = true;
            $scope.selectedGroupList = [];
            $scope.isAllGroups = false;
            _.each($scope.groupList, function(group) {
                group.isSelected = false;
            })
            if ($scope.selectedStudentList.length === 0) {
                //[Object] - List of student Ids
                let list = [];
                _.each($scope.allStudents, function(student) {
                    list.push({
                        _id: student._id,
                        name: student.name
                    });
                })
                $scope.selectedStudentList = list;
                $scope.selectedGroupList = [];
            } else
                $scope.selectedStudentList = []

        }

        $scope.allGroupSelected = () => {
            $scope.isServerCall = true;
            $scope.selectedGroupList = [];
            $scope.isAllStudents = false;
            //[Object] - List of student Ids
            let list = [];
            _.each($scope.groupList, function(group) {
                group.isSelected = !$scope.isAllGroups;
                if (group.isSelected)
                    list.push({
                        _id: group._id
                    })
            })
            $scope.selectedGroupList = list;
            $scope.selectedStudentList = [];
        }

        $scope.groupSelected = (group, index) => {
            $scope.isServerCall = true;
            $scope.isAllStudents = false;
            $scope.selectedStudentList = [];
            if (!group.isSelected) {
                if ($scope.selectedGroupList.findIndex(i => i._id === group._id) == -1)
                    $scope.selectedGroupList.push({
                        _id: group._id
                    });
            } else
                $scope.selectedGroupList = _.without($scope.selectedGroupList, _.findWhere($scope.selectedGroupList, {
                    _id: group._id
                }))
            if ($scope.selectedGroupList.length == $scope.groupList.length)
                $scope.isAllGroups = true
            else
                $scope.isAllGroups = false
        }

        $scope.assignGroupUsers = () => {
            let previousState = $scope.previousState;
            if (previousState.state === "") {
                previousState = localStorageService.get('assignUserHistory')
                localStorageService.clear('assignUserHistory')
            }
            if ($scope.selectedStudentList.length > 0 || $scope.selectedGroupList.length > 0) {
                if ($scope.selectedGroupList.length > 0) {
                    $scope.assignedUsers = {
                        type: "group",
                        list: $scope.selectedGroupList
                    }
                }
                if ($scope.selectedStudentList.length > 0) {
                    $scope.assignedUsers = {
                        type: "all",
                        list: $scope.selectedStudentList
                    }
                }
            } else {
                toastr.error("Select Students to assign")
                return false;
            }
            if ($scope.isServerCall) {
                if (qpId) {
                    let assigneeDetails = {
                        qp_id: qpId,
                        assigned_users: $scope.assignedUsers,
                        academic_details: academicDetails,
                        user_id: userId
                    }
                    console.log(assigneeDetails)
                    authService.callAPI(activityCons.API_UPDATE_ASSIGNEE_DETAILS, "POST", assigneeDetails, function(response) {
                        if (response && response.result && response.result.data) {
                            toastr.success("Students assigned")
                            $state.go("qpSummary", {
                                qpId: qpId
                            })
                        }

                    })
                }
            } else {
                $state.go(previousState.state, previousState.params)
            }

        }

        $scope.cancelAssignUser = () => {
            $state.go('qpSummary', {
                qpId: qpId
            })
        }

        $scope.createNewGroup = () => {
            $state.go('createStudentGroup', {
                qpId: qpId,
                groupId: ""
            })
        }

        $scope.toggleExpansion = function(accordianData, selectedData, index) {
            _.each(accordianData, function(data, dataIndex) {
                if (dataIndex != index)
                    data.expanded = false;
                else
                    data.expanded = !selectedData.expanded;
            })
        }

        /*
         * Function to open menu
         *
         * @return : null
         */
        $scope.openMenu = function($mdOpenMenu, ev) {
            let originatorEv = ev;
            $mdOpenMenu(ev);
        };

        $scope.editGroup = function(groupId) {
            $state.go('createStudentGroup', {
                qpId: qpId,
                groupId: groupId
            })
        }


        $scope.deleteGroup = function(groupId) {
            var confirm = $mdDialog.confirm()
                .textContent('Do you want to delete Group?')
                .ok('Yes')
                .cancel('No');
            $mdDialog.show(confirm).then(function() {
                authService.callAPI(activityCons.API_DELETE_GROUP + groupId, "GET", {}, function(response) {
                    if (response && response.result && response.result.data) {
                        toastr.success("Student group deleted successfully")
                        getGroupList()
                        getAllStudents()
                    }
                })

            }, function() {});
        }

        this.$onDestroy = () => {

        }

    }
}

export default AssignStudents;



// WEBPACK FOOTER //
// ./src/app/traditionalActivity/controllers/assignStudents.js